import styled from '@emotion/styled';
import { np } from '@kc-console/core';

import { ServiceButton } from '../ServiceButton';

/** 더보기 메뉴 항목 버튼 스타일. FavoriteDragLayer가 메뉴 출처 드래그 프리뷰에도 같은 모양을 쓴다 */
export const MoreItemServiceButton = styled(ServiceButton, {
  shouldForwardProp: np('isDragging'),
})<{
  /** 드래그 중인 소스 버튼 흐림 표시. DragLayer 프리뷰는 미전달(opacity 1) */
  isDragging?: boolean;
}>`
  padding: 6px 16px;
  height: 33px;
  min-width: 200px;
  justify-content: flex-start;
  opacity: ${({ isDragging }) => (isDragging ? 0.4 : 1)};

  /* 호버는 버튼 기본 pointer, 누르는 동안(드래그 시작 전)만 grab.
     네이티브 드래그 시작 후의 커서는 브라우저가 제어하므로 CSS로 바꿀 수 없다. */
  &:active {
    cursor: grab;
  }
`;
